/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/helpers/set-root-css-var.js":
/*!********************************************!*\
  !*** ./src/js/helpers/set-root-css-var.js ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   setRootCssVarPx: () => (/* binding */ setRootCssVarPx)
/* harmony export */ });
function setRootCssVarPx(root, name, px) {
  var next = "".concat(Math.max(0, Math.round(px)), "px");
  if (root.style.getPropertyValue(name) === next) return false;
  root.style.setProperty(name, next);
  return true;
}

/***/ }),

/***/ "./src/js/modules/ed-cart-progress-bar.js":
/*!************************************************!*\
  !*** ./src/js/modules/ed-cart-progress-bar.js ***!
  \************************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// ed-cart-progress-bar (Free-Gift Logik)
// -----------------------------------------------------------------------------
// Die Progress-Bar-Anzeige selbst rendert Liquid (snippets/ed-cart-progress-bar).
// Der Cart-Drawer rendert bei JEDER Änderung die komplette .drawer__inner neu
// (renderContents / updateQuantity). Wichtige Folge fürs JS-Design:
//
//   -> Bar, Geschenk-Prompts und Geschenk-Zeilen werden bei jedem Cart-Update
//      ZERSTÖRT und NEU erzeugt. Nur <cart-drawer> selbst bleibt bestehen.
//
// Deshalb liegt der übergreifende, zustandsbehaftete Teil (Auto-Add-Lock, der
// Open-Observer, das Dismissal) als STATISCHER Teil auf der jeweiligen Component
// (überlebt den Re-Render), nicht als Instanz-State auf einem kurzlebigen Element.
//
//   EdCartGiftAdd       - Geschenk-Prompt: Klick ODER Auto-Add legt das Geschenk
//                         mit Property _ed_free_gift in den Warenkorb. Besitzt
//                         Auto-Add, Open-Observer und Dismissal (statisch).
//   EdCartGiftReconcile - entfernt Geschenke, die nicht mehr in den Warenkorb
//                         gehören (Liquid liefert die Line-Item-Keys: Aktion
//                         beendet, ausverkauft oder Schwelle unterschritten).
//                         Läuft bewusst AUCH bei geschlossenem Drawer, damit
//                         alte Geschenke nicht bis in den Checkout überleben.
//
// getCartDrawer/postCart/renderCart sind generische Cart-I/O-Helfer, die BEIDE
// Components nutzen -> bewusst geteilte Modul-Utilities, nicht Methoden einer
// einzelnen Component.

var GIFT_ADD_TAG = 'ed-cart-gift-add';
var GIFT_RECONCILE_TAG = 'ed-cart-gift-reconcile';
var SELECTORS = {
  addButton: '[data-gift-add]',
  variantModal: '[data-gift-variant-modal]',
  variantClose: '[data-gift-variant-close]',
  variantSelect: '[data-gift-variant-select]',
  variantAdd: '[data-gift-variant-add]',
  variantImage: '[data-gift-variant-image]',
  variantPrice: '[data-gift-variant-price]'
};

// State-Klassen des Theme-Modals (quick-add-modal) — für identische Optik ohne
// die Theme-JS (die bindet an [data-quick-add-modal], nicht an die Klasse).
var MODAL_CLASSES = {
  fixed: 'is-fixed',
  visible: 'is-visible',
  active: 'active'
};
var GIFT_PROPERTY = '_ed_free_gift';
// Schwelle (Shop-Währung), ab der die Cart-Transform das Geschenk auf 0 € setzt.
var GIFT_THRESHOLD_PROPERTY = '_ed_free_gift_threshold';

// Marker am Entfernen-Button + sessionStorage-Präfix fürs Dismissal.
var DISMISS_ATTR = 'data-gift-dismiss-variant';
var DISMISS_KEY_PREFIX = 'ed_free_gift_dismissed_';

// --- Generische Cart-I/O-Helfer (von beiden Components genutzt) ---------------

function getCartDrawer() {
  return document.querySelector('cart-drawer');
}
function resolveRoute(name, fallback) {
  return window.routes && window.routes[name] || fallback;
}

// Das <cart-items>-Element der Warenkorb-SEITE (main-cart). Der Drawer liegt
// global im Layout, auf /cart existieren also BEIDE — und beide müssen nach
// einer Änderung neu gerendert werden.
function getMainCartItems() {
  return document.querySelector('cart-items');
}

// ed-custom.js wird im Layout-Head per defer eingebunden, cart.js/cart-drawer.js
// erst im Drawer-Snippet im Body. Deferred Scripts laufen in Dokumentreihenfolge
// -> beim Upgrade UNSERER Elemente sind <cart-drawer>/<cart-items> noch nicht
// aufgewertet und haben weder getSectionsToRender noch renderContents.
// Alles, was direkt beim Seitenaufruf Cart-I/O macht, muss daher erst warten.
function whenCartComponentsReady() {
  var pending = [];
  ['cart-drawer', 'cart-items'].forEach(function (tag) {
    if (document.querySelector(tag) && !customElements.get(tag)) {
      pending.push(customElements.whenDefined(tag));
    }
  });
  return Promise.all(pending);
}

// Section-Liste des Warenkorb-Seiten-Elements. getSectionsToRender() greift dort
// ungeprüft auf #main-cart-items/#main-cart-footer zu -> defensiv kapseln.
function getMainCartSections() {
  var cartItems = getMainCartItems();
  if (!cartItems || typeof cartItems.getSectionsToRender !== 'function') return [];
  try {
    return cartItems.getSectionsToRender();
  } catch (_) {
    return [];
  }
}

// POST auf eine Cart-Route (add/change) inkl. aller Sections, die danach neu
// gerendert werden müssen — Drawer und (falls vorhanden) Warenkorb-Seite.
function postCart(url, payload) {
  var cartDrawer = getCartDrawer();
  var sections = [];
  if (cartDrawer) {
    cartDrawer.getSectionsToRender().forEach(function (section) {
      return sections.push(section.id);
    });
  }
  // Warenkorb-Seite: die Section-ID steht in `section`, nicht in `id`.
  getMainCartSections().forEach(function (section) {
    return sections.push(section.section);
  });
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify(_objectSpread(_objectSpread({}, payload), {}, {
      sections: sections.filter(function (id, index) {
        return id && sections.indexOf(id) === index;
      }),
      sections_url: window.location.pathname
    }))
  }).then(function (response) {
    return response.json();
  });
}

// Tauscht die Warenkorb-Bereiche aus, OHNE den Drawer zu öffnen.
// cart-drawer.renderContents() ruft am Ende open() auf — beim stillen Aufräumen
// (Reconcile bei geschlossenem Drawer) wäre genau das ein Bug: Der Warenkorb
// würde beim reinen Seitenaufruf aufspringen.
function renderCartSilently(state) {
  // Auf /cart fordern beide Listen dieselbe cart-icon-bubble an — jede Section
  // nur EINMAL schreiben, sonst überschreibt der zweite Durchlauf die Struktur
  // des ersten (unterschiedliche Selektoren).
  var rendered = [];
  var cartItems = getMainCartItems();
  if (cartItems) {
    getMainCartSections().forEach(function (section) {
      var host = document.getElementById(section.id);
      var html = state.sections[section.section];
      if (!host || html == null) return;
      var target = host.querySelector(section.selector) || host;
      target.innerHTML = cartItems.getSectionInnerHTML(html, section.selector);
      rendered.push(section.section);
    });
  }
  var cartDrawer = getCartDrawer();
  if (cartDrawer) {
    cartDrawer.getSectionsToRender().forEach(function (section) {
      if (rendered.indexOf(section.id) !== -1) return;
      var html = state.sections[section.id];
      var target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (!target || html == null) return;
      target.innerHTML = cartDrawer.getSectionInnerHTML(html, section.selector);
    });
  }
}

// Warenkorb neu rendern. Bei OFFENEM Drawer über den Theme-Weg (hält ihn offen
// und hängt den Overlay-Handler neu ein), sonst still.
function renderCart(state) {
  var cartDrawer = getCartDrawer();
  if (!state || !state.sections) return;
  if (cartDrawer && cartDrawer.classList.contains('active')) {
    cartDrawer.renderContents(state);
  } else {
    renderCartSilently(state);
  }
}

// --- Geschenk-Prompt: Hinzufügen, Auto-Add, Dismissal -------------------------
var EdCartGiftAdd = /*#__PURE__*/function (_HTMLElement) {
  function EdCartGiftAdd() {
    _classCallCheck(this, EdCartGiftAdd);
    return _callSuper(this, EdCartGiftAdd, arguments);
  }
  _inherits(EdCartGiftAdd, _HTMLElement);
  return _createClass(EdCartGiftAdd, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this = this;
      this._busy = false;
      // Mehrere verfügbare Varianten -> Auswahl-Popover statt Direkt-Hinzufügen.
      this._multi = this.dataset.variantSelect === 'true';
      this._button = this.querySelector(SELECTORS.addButton);
      this._modal = this.querySelector(SELECTORS.variantModal);
      this._onKeydown = this._onKeydown.bind(this);
      if (this._button) {
        this._button.addEventListener('click', this._onAddClick.bind(this));
      }
      if (this._multi && this._modal) {
        this._select = this._modal.querySelector(SELECTORS.variantSelect);
        var addButton = this._modal.querySelector(SELECTORS.variantAdd);
        if (addButton) addButton.addEventListener('click', function () {
          return _this._onVariantAdd();
        });
        if (this._select) {
          this._select.addEventListener('change', function () {
            return _this._syncVariant();
          });
          this._syncVariant(); // Bild/Preis initial an die vorausgewählte Variante angleichen
        }
        this.querySelectorAll(SELECTORS.variantClose).forEach(function (closer) {
          closer.addEventListener('click', function (event) {
            event.preventDefault();
            _this._closeModal();
          });
        });
      }

      // Prompt wird in einen bereits OFFENEN Drawer gerendert (z. B. eine Mengen-
      // änderung überschreitet die Schwelle) -> sofort prüfen. Den Fall "Produkt
      // hinzufügen -> Drawer öffnet erst danach" deckt der Open-Observer ab.
      EdCartGiftAdd.runAutoAdd();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      // Element wird beim Drawer-Re-Render zerstört -> globalen Keydown-Listener lösen
      // und ein evtl. nach <body> portiertes Popover aufräumen.
      document.removeEventListener('keydown', this._onKeydown);
      if (this._modal && this._modal.parentNode === document.body) {
        this._modal.remove();
      }
    }
  }, {
    key: "_onAddClick",
    value: function _onAddClick(event) {
      event.preventDefault();
      if (this._multi) {
        this._openModal();
      } else {
        this._add(this.dataset.variantId);
      }
    }
  }, {
    key: "_onVariantAdd",
    value: function _onVariantAdd() {
      var variantId = this._select ? this._select.value : this.dataset.variantId;
      this._closeModal();
      this._add(variantId);
    }

    // Bild + durchgestrichenen Preis an die im Dropdown gewählte Variante anpassen.
  }, {
    key: "_syncVariant",
    value: function _syncVariant() {
      if (!this._select || !this._modal) return;
      var option = this._select.options[this._select.selectedIndex];
      if (!option) return;
      var image = this._modal.querySelector(SELECTORS.variantImage);
      var price = this._modal.querySelector(SELECTORS.variantPrice);
      if (image && option.dataset.image) image.src = option.dataset.image;
      if (price && option.dataset.price) price.textContent = option.dataset.price;
    }
  }, {
    key: "_onKeydown",
    value: function _onKeydown(event) {
      if (event.keyCode === 27) this._closeModal();
    }

    // Varianten-Popover öffnen. Das Popover wird nach <body> portiert, weil der
    // Drawer-Container (.quick-cart__container) transform + overflow:hidden hat —
    // ein position:fixed-Kind darin würde relativ zum Drawer positioniert und
    // abgeschnitten. Danach Theme-States: erst is-fixed (sichtbar), nach einem
    // Reflow is-visible/active für die Slide-in-Transition.
  }, {
    key: "_openModal",
    value: function _openModal() {
      if (!this._modal) return;
      document.body.appendChild(this._modal);
      this._modal.classList.add(MODAL_CLASSES.fixed);
      void this._modal.offsetWidth; // Reflow erzwingen, damit die Transition greift
      this._modal.classList.add(MODAL_CLASSES.visible, MODAL_CLASSES.active);
      document.addEventListener('keydown', this._onKeydown);
    }
  }, {
    key: "_closeModal",
    value: function _closeModal() {
      if (!this._modal) return;
      var modal = this._modal;
      modal.classList.remove(MODAL_CLASSES.visible, MODAL_CLASSES.active);
      document.removeEventListener('keydown', this._onKeydown);
      // Nach der Slide-out-Transition ausblenden und das portierte Popover aus dem
      // <body> lösen (ein erneutes Öffnen hängt es wieder an).
      setTimeout(function () {
        modal.classList.remove(MODAL_CLASSES.fixed);
        modal.remove();
      }, 300);
    }

    // Auto-Add nur bei EINER Variante (Multi braucht die Kundenauswahl), aktiv
    // (data-auto-add), Geschenk nicht vom Kunden entfernt, nicht busy.
  }, {
    key: "_eligibleForAutoAdd",
    value: function _eligibleForAutoAdd() {
      return !this._multi && this.dataset.autoAdd === 'true' && Boolean(this.dataset.variantId) && !this._busy && !EdCartGiftAdd.isDismissed(this.dataset.variantId);
    }

    // Legt die gewählte Variante mit den Free-Gift-Properties in den Warenkorb und
    // rendert den Drawer neu. Wird von Klick, Varianten-Auswahl UND Auto-Add genutzt.
  }, {
    key: "_add",
    value: function _add(variantId) {
      var _this2 = this;
      if (this._busy) return Promise.resolve();
      var id = parseInt(variantId, 10);
      if (!id) return Promise.resolve();
      this._busy = true;
      if (this._button) this._button.setAttribute('aria-busy', 'true');
      var properties = _defineProperty({}, GIFT_PROPERTY, true);
      if (this.dataset.threshold) {
        properties[GIFT_THRESHOLD_PROPERTY] = this.dataset.threshold;
      }
      return postCart(resolveRoute('cart_add_url', '/cart/add'), {
        id: id,
        quantity: 1,
        properties: properties
      }).then(renderCart)["catch"](function () {})["finally"](function () {
        _this2._busy = false;
        if (_this2._button) _this2._button.removeAttribute('aria-busy');
      });
    }

    // -- statisch: übergreifende Logik, die den Re-Render überlebt ---------------
  }], [{
    key: "dismissKey",
    value: function dismissKey(variantId) {
      return DISMISS_KEY_PREFIX + variantId;
    }

    // "Vom Kunden manuell entfernt" pro Sitzung merken, damit Auto-Add nicht sofort
    // wieder hinzufügt. sessionStorage -> gilt nur für die aktuelle Sitzung.
  }, {
    key: "isDismissed",
    value: function isDismissed(variantId) {
      if (!variantId) return false;
      try {
        return sessionStorage.getItem(EdCartGiftAdd.dismissKey(variantId)) === '1';
      } catch (_) {
        return false;
      }
    }
  }, {
    key: "markDismissed",
    value: function markDismissed(variantId) {
      if (!variantId) return;
      try {
        sessionStorage.setItem(EdCartGiftAdd.dismissKey(variantId), '1');
      } catch (_) {
        /* sessionStorage nicht verfügbar (Privat-Modus o. Ä.) -> Auto-Add greift weiter */
      }
    }

    // Fügt – nur bei OFFENEM Drawer – das erste noch offene Auto-Add-Geschenk hinzu.
    // isAutoAdding serialisiert; nach dem Re-Render stößt der nächste Prompt das
    // nächste Geschenk an. Der Offen-Check verhindert ungewolltes Öffnen beim reinen
    // Seitenaufruf (analog EdCartGiftReconcile).
  }, {
    key: "runAutoAdd",
    value: function runAutoAdd() {
      if (EdCartGiftAdd.isAutoAdding) return;
      var cartDrawer = getCartDrawer();
      if (!cartDrawer || !cartDrawer.classList.contains('active')) return;
      var target = null;
      cartDrawer.querySelectorAll(GIFT_ADD_TAG).forEach(function (el) {
        if (!target && typeof el._eligibleForAutoAdd === 'function' && el._eligibleForAutoAdd()) {
          target = el;
        }
      });
      if (!target) return;
      EdCartGiftAdd.isAutoAdding = true;
      target._add(target.dataset.variantId)["finally"](function () {
        EdCartGiftAdd.isAutoAdding = false;
      });
    }

    // Einmalige, globale Setups auf dem PERSISTENTEN <cart-drawer> (überleben die
    // Re-Renders der Drawer-Innereien) — daher gebündelt hier statt im
    // connectedCallback eines kurzlebigen Elements:
    //  1. Manuelles Entfernen (cart-remove-button) als Dismissal merken.
    //  2. Beim Öffnen des Drawers Auto-Add anstoßen (renderContents öffnet den
    //     Drawer per setTimeout ERST NACH dem Rendern; deckt auch das manuelle
    //     Öffnen bei bereits qualifiziertem Warenkorb ab).
  }, {
    key: "init",
    value: function init() {
      if (window.__edFreeGiftInited) return;
      window.__edFreeGiftInited = true;

      // (1) Dismissal: delegiert + Capture-Phase, damit es unabhängig vom nativen
      // Remove-Handler feuert und Re-Renders überlebt. Reconcile entfernt per fetch
      // (kein Klick) -> löst das bewusst NICHT aus (Reconcile != Dismissal).
      document.addEventListener('click', function (event) {
        var trigger = event.target.closest && event.target.closest('[' + DISMISS_ATTR + ']');
        if (trigger) EdCartGiftAdd.markDismissed(trigger.getAttribute(DISMISS_ATTR));
      }, true);

      // (2) Open-Observer auf dem persistenten <cart-drawer>.
      var attachOpenObserver = function attachOpenObserver() {
        var cartDrawer = getCartDrawer();
        if (!cartDrawer) return;
        var wasActive = cartDrawer.classList.contains('active');
        new MutationObserver(function () {
          var isActive = cartDrawer.classList.contains('active');
          if (isActive && !wasActive) EdCartGiftAdd.runAutoAdd();
          wasActive = isActive;
        }).observe(cartDrawer, {
          attributes: true,
          attributeFilter: ['class']
        });
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', attachOpenObserver);
      } else {
        attachOpenObserver();
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Serialisiert Auto-Adds über die Re-Render-Zyklen hinweg.
EdCartGiftAdd.isAutoAdding = false;

// --- Geschenk-Reconcile: entfernt Geschenke unter der Schwelle ----------------
var EdCartGiftReconcile = /*#__PURE__*/function (_HTMLElement2) {
  function EdCartGiftReconcile() {
    _classCallCheck(this, EdCartGiftReconcile);
    return _callSuper(this, EdCartGiftReconcile, arguments);
  }
  _inherits(EdCartGiftReconcile, _HTMLElement2);
  return _createClass(EdCartGiftReconcile, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this3 = this;
      if (EdCartGiftReconcile.isReconciling) return;

      // Bewusst KEIN "nur bei offenem Drawer"-Guard: Ein Geschenk aus einer
      // beendeten Aktion liegt oft in einem Warenkorb, den der Kunde nie wieder
      // öffnet — er geht von der Warenkorb-Seite direkt zur Kasse und bekommt dort
      // Shopifys "Ausverkauft"-Dialog. Das Aufspringen des Drawers verhindert
      // stattdessen renderCart(), das bei geschlossenem Drawer still rendert.
      var keys = (this.dataset.orphanGiftKeys || '').split(',').map(function (key) {
        return key.trim();
      }).filter(Boolean);
      if (!keys.length) return;
      EdCartGiftReconcile.isReconciling = true;
      // Erst wenn <cart-drawer>/<cart-items> aufgewertet sind — sonst fehlen beim
      // Seitenaufruf getSectionsToRender/getSectionInnerHTML (siehe
      // whenCartComponentsReady).
      whenCartComponentsReady().then(function () {
        return _this3._removeAll(keys);
      })["catch"](function (error) {
        console.warn('[ed-free-gift] Reconcile fehlgeschlagen', error);
      })["finally"](function () {
        EdCartGiftReconcile.isReconciling = false;
      });
    }

    // Alle Orphan-Keys nacheinander entfernen, danach den Warenkorb EINMAL neu
    // rendern. (Kein Re-Render mitten in der Schleife, um Race-Conditions zu
    // vermeiden.)
  }, {
    key: "_removeAll",
    value: function () {
      var _removeAll2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(keys) {
        var lastState, _iterator, _step, key, state, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              lastState = null;
              _iterator = _createForOfIteratorHelper(keys);
              _context.p = 1;
              _iterator.s();
            case 2:
              if ((_step = _iterator.n()).done) {
                _context.n = 6;
                break;
              }
              key = _step.value;
              _context.n = 3;
              return postCart(resolveRoute('cart_change_url', '/cart/change'), {
                id: key,
                quantity: 0
              });
            case 3:
              state = _context.v;
              if (!(!state || state.status)) {
                _context.n = 4;
                break;
              }
              console.warn('[ed-free-gift] Geschenk konnte nicht entfernt werden', key, state);
              return _context.a(3, 5);
            case 4:
              lastState = state;
            case 5:
              _context.n = 2;
              break;
            case 6:
              _context.n = 8;
              break;
            case 7:
              _context.p = 7;
              _t = _context.v;
              _iterator.e(_t);
            case 8:
              _context.p = 8;
              _iterator.f();
              return _context.f(8);
            case 9:
              renderCart(lastState);
            case 10:
              return _context.a(2);
          }
        }, _callee, null, [[1, 7, 8, 9]]);
      }));
      function _removeAll(_x) {
        return _removeAll2.apply(this, arguments);
      }
      return _removeAll;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Verhindert überlappende Reconcile-Läufe über Re-Render-Zyklen hinweg.
EdCartGiftReconcile.isReconciling = false;

// --- Registrierung ------------------------------------------------------------

EdCartGiftAdd.init();
if (!customElements.get(GIFT_ADD_TAG)) {
  customElements.define(GIFT_ADD_TAG, EdCartGiftAdd);
}
if (!customElements.get(GIFT_RECONCILE_TAG)) {
  customElements.define(GIFT_RECONCILE_TAG, EdCartGiftReconcile);
}

/***/ }),

/***/ "./src/js/modules/ed-filter-accordion.js":
/*!***********************************************!*\
  !*** ./src/js/modules/ed-filter-accordion.js ***!
  \***********************************************/
/***/ (() => {

var ACCORDION_SELECTOR = '.filter-drawer--all-products .filter-drawer__accordion';
var BODY_SELECTOR = '.filter-drawer__group-body';
var BADGE_SELECTOR = '[data-group-badge]';
var CHECKBOX_SELECTOR = '.filter-item__checkbox';
var EASING = 'cubic-bezier(0.32, 0.72, 0, 1)';
var MIN_DURATION = 0.45;
var MAX_DURATION = 0.7;
var MAX_BODY_HEIGHT = 22.5;
var MIN_BODY_HEIGHT = 11.25;
function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
function getTransitionDuration(targetHeight) {
  var normalized = Math.min(Math.max(targetHeight / 720, 0), 1);
  return MIN_DURATION + (MAX_DURATION - MIN_DURATION) * normalized;
}
function getTransition(targetHeight) {
  var duration = getTransitionDuration(targetHeight);
  return "height ".concat(duration, "s ").concat(EASING, ", opacity ").concat(duration, "s ").concat(EASING, ", padding ").concat(duration, "s ").concat(EASING);
}
function resetBodyStyles(body) {
  body.style.transition = '';
  body.style.height = 'auto';
  body.style.opacity = '';
  body.style.overflow = '';
  body.style.overflowY = '';
  body.style.paddingBottom = '';
}
function setClosedStyles(body) {
  body.style.transition = '';
  body.style.height = '0px';
  body.style.opacity = '0';
  body.style.overflow = 'hidden';
  body.style.overflowY = 'hidden';
  body.style.paddingBottom = '0px';
}
function measureBody(body, details, summary) {
  body.style.transition = 'none';
  body.style.height = 'auto';
  body.style.overflow = 'visible';
  body.style.overflowY = 'visible';
  body.style.paddingBottom = '1rem';
  body.style.opacity = '1';
  var fullHeight = body.scrollHeight;
  var content = details.closest('.filter-drawer__content');
  var availableMax = MAX_BODY_HEIGHT * 16;
  if (content && summary) {
    var contentRect = content.getBoundingClientRect();
    var summaryRect = summary.getBoundingClientRect();
    var panel = details.closest('.filter-drawer__panel');
    var footer = panel === null || panel === void 0 ? void 0 : panel.querySelector('.filter-drawer__footer');
    var footerHeight = (footer === null || footer === void 0 ? void 0 : footer.getBoundingClientRect().height) || 0;
    var spaceBelow = contentRect.bottom - summaryRect.bottom - footerHeight - 24;
    availableMax = Math.min(MAX_BODY_HEIGHT * 16, Math.max(MIN_BODY_HEIGHT * 16, spaceBelow));
  }
  var targetHeight = Math.min(fullHeight, availableMax);
  return {
    fullHeight: fullHeight,
    targetHeight: targetHeight,
    needsScroll: fullHeight > targetHeight
  };
}
function setupAccordion(details) {
  if (details.dataset.accordionReady === 'true') return;
  var summary = details.querySelector('summary');
  var body = details.querySelector(BODY_SELECTOR);
  if (!summary || !body) return;
  details.dataset.accordionReady = 'true';
  var collapse = function collapse() {
    if (prefersReducedMotion()) {
      details.open = false;
      setClosedStyles(body);
      return;
    }
    var startHeight = body.offsetHeight;
    body.style.transition = 'none';
    body.style.height = "".concat(startHeight, "px");
    body.style.overflow = 'hidden';
    body.style.overflowY = 'hidden';
    body.offsetHeight;
    body.style.transition = getTransition(startHeight);
    body.style.height = '0px';
    body.style.opacity = '0';
    body.style.paddingBottom = '0px';
    var _onEnd = function onEnd(event) {
      if (event.target !== body || event.propertyName !== 'height') return;
      body.removeEventListener('transitionend', _onEnd);
      details.open = false;
      setClosedStyles(body);
    };
    body.addEventListener('transitionend', _onEnd);
  };
  var expand = function expand() {
    if (prefersReducedMotion()) {
      resetBodyStyles(body);
      body.style.paddingBottom = '1rem';
      return;
    }
    var _measureBody = measureBody(body, details, summary),
      targetHeight = _measureBody.targetHeight,
      needsScroll = _measureBody.needsScroll;
    body.style.height = '0px';
    body.style.opacity = '0';
    body.style.paddingBottom = '0px';
    body.style.overflow = 'hidden';
    body.style.overflowY = 'hidden';
    body.offsetHeight;
    body.style.transition = getTransition(targetHeight);
    body.style.height = "".concat(targetHeight, "px");
    body.style.opacity = '1';
    body.style.paddingBottom = '1rem';
    var _onEnd2 = function onEnd(event) {
      if (event.target !== body || event.propertyName !== 'height') return;
      body.removeEventListener('transitionend', _onEnd2);
      if (needsScroll) {
        body.style.transition = '';
        body.style.height = "".concat(targetHeight, "px");
        body.style.overflowY = 'auto';
        body.style.opacity = '1';
        body.style.paddingBottom = '1rem';
      } else {
        resetBodyStyles(body);
        body.style.paddingBottom = '1rem';
      }
    };
    body.addEventListener('transitionend', _onEnd2);
    requestAnimationFrame(function () {
      summary.scrollIntoView({
        block: 'nearest',
        behavior: 'smooth'
      });
    });
  };
  summary.addEventListener('click', function (event) {
    if (details.open) {
      event.preventDefault();
      collapse();
    }
  });
  details.addEventListener('toggle', function () {
    if (details.open) {
      expand();
    }
  });
  if (details.open) {
    var _measureBody2 = measureBody(body, details, summary),
      targetHeight = _measureBody2.targetHeight,
      needsScroll = _measureBody2.needsScroll;
    if (needsScroll) {
      body.style.height = "".concat(targetHeight, "px");
      body.style.overflowY = 'auto';
      body.style.opacity = '1';
      body.style.paddingBottom = '1rem';
    } else {
      resetBodyStyles(body);
      body.style.paddingBottom = '1rem';
    }
  } else {
    setClosedStyles(body);
  }
}
function updateGroupBadge(details) {
  var badge = details.querySelector(BADGE_SELECTOR);
  if (!badge) return;
  var checkedCount = details.querySelectorAll("".concat(CHECKBOX_SELECTOR, ":checked:not(:disabled)")).length;
  if (checkedCount > 0) {
    badge.textContent = checkedCount;
    badge.hidden = false;
    details.setAttribute('data-active-group', '');
  } else {
    badge.textContent = '';
    badge.hidden = true;
    details.removeAttribute('data-active-group');
  }
}
function initGroupBadges() {
  var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  scope.querySelectorAll(ACCORDION_SELECTOR).forEach(updateGroupBadge);
}
function initFilterAccordions() {
  var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  scope.querySelectorAll(ACCORDION_SELECTOR).forEach(setupAccordion);
  initGroupBadges(scope);
}
function bindFilterAccordionEvents() {
  document.addEventListener('change', function (event) {
    var checkbox = event.target;
    if (!checkbox.matches('.filter-drawer--all-products .filter-item__checkbox')) return;
    var details = checkbox.closest('.filter-drawer__accordion');
    if (details) updateGroupBadge(details);
  });
  document.addEventListener('click', function (event) {
    var clearButton = event.target.closest('.filter-drawer--all-products [data-button="clear-all"]');
    if (!clearButton) return;
    requestAnimationFrame(function () {
      initGroupBadges();
    });
  });
  document.addEventListener('products:loaded', function () {
    return initFilterAccordions();
  });
  document.addEventListener('collection:updated', function () {
    return initFilterAccordions();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    initFilterAccordions();
    bindFilterAccordionEvents();
  }, {
    once: true
  });
} else {
  initFilterAccordions();
  bindFilterAccordionEvents();
}

/***/ }),

/***/ "./src/js/modules/ed-founders-gf-ratings-cleanup.js":
/*!**********************************************************!*\
  !*** ./src/js/modules/ed-founders-gf-ratings-cleanup.js ***!
  \**********************************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var CUSTOM_ELEMENT_NAME = 'ed-founders-gf-ratings-cleanup';
var FOUNDERS_SECTION_SELECTOR = '.bd-founders-gf';
var RATING_COUNT_SELECTOR = '.ruk_rating_snippet .ruk-rating-snippet-count';
var RATING_LABEL_REGEX = /\s*Bewertungen?\b/gi;
var MAX_RETRY_ATTEMPTS = 20;
var RETRY_DELAY_MS = 200;
var EdFoundersGfRatingsCleanup = /*#__PURE__*/function (_HTMLElement) {
  function EdFoundersGfRatingsCleanup() {
    _classCallCheck(this, EdFoundersGfRatingsCleanup);
    return _callSuper(this, EdFoundersGfRatingsCleanup, arguments);
  }
  _inherits(EdFoundersGfRatingsCleanup, _HTMLElement);
  return _createClass(EdFoundersGfRatingsCleanup, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._foundersSection = this.closest(FOUNDERS_SECTION_SELECTOR);
      if (!this._foundersSection) return;
      this._retryAttemptCount = 0;
      this._runCleanupWithRetry();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this._timer) window.clearTimeout(this._timer);
    }
  }, {
    key: "_cleanOnce",
    value: function _cleanOnce() {
      var ratingCountNodes = this._foundersSection.querySelectorAll(RATING_COUNT_SELECTOR);
      ratingCountNodes.forEach(function (node) {
        node.textContent = node.textContent.replace(RATING_LABEL_REGEX, '').trim();
      });
      return ratingCountNodes.length > 0;
    }
  }, {
    key: "_runCleanupWithRetry",
    value: function _runCleanupWithRetry() {
      var _this = this;
      var hasRatingCountNodes = this._cleanOnce();
      if (hasRatingCountNodes) return;
      this._retryAttemptCount += 1;
      if (this._retryAttemptCount >= MAX_RETRY_ATTEMPTS) return;
      this._timer = window.setTimeout(function () {
        _this._runCleanupWithRetry();
      }, RETRY_DELAY_MS);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get(CUSTOM_ELEMENT_NAME)) {
  customElements.define(CUSTOM_ELEMENT_NAME, EdFoundersGfRatingsCleanup);
}

/***/ }),

/***/ "./src/js/modules/ed-header-layout-sync.js":
/*!*************************************************!*\
  !*** ./src/js/modules/ed-header-layout-sync.js ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _helpers_set_root_css_var__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers/set-root-css-var */ "./src/js/helpers/set-root-css-var.js");

function initHeaderLayoutSync() {
  var root = document.documentElement;
  var header = document.querySelector('.bd-header');
  if (!header) return;
  var setHeaderHeight = function setHeaderHeight() {
    var h = header.getBoundingClientRect().height;
    (0,_helpers_set_root_css_var__WEBPACK_IMPORTED_MODULE_0__.setRootCssVarPx)(root, '--header-height', h);
  };
  var syncDeskMegaMenuTop = function syncDeskMegaMenuTop() {
    var bottom = header.getBoundingClientRect().bottom;
    (0,_helpers_set_root_css_var__WEBPACK_IMPORTED_MODULE_0__.setRootCssVarPx)(root, '--desk-mega-menu-top', bottom);
  };
  window.__syncDeskMegaMenuTop = syncDeskMegaMenuTop;
  var syncHeaderLayout = function syncHeaderLayout() {
    setHeaderHeight();
    if (typeof window.syncAnnouncementHeightFromDom === 'function') {
      window.syncAnnouncementHeightFromDom();
    } else {
      syncDeskMegaMenuTop();
    }
  };
  syncHeaderLayout();
  window.addEventListener('load', syncHeaderLayout, {
    once: true
  });
  if (window.ResizeObserver) {
    var headerRoRaf = null;
    var ro = new ResizeObserver(function () {
      if (headerRoRaf !== null) return;
      headerRoRaf = requestAnimationFrame(function () {
        headerRoRaf = null;
        syncHeaderLayout();
      });
    });
    ro.observe(header);
  }
  var onViewportChange = function onViewportChange() {
    return requestAnimationFrame(syncHeaderLayout);
  };
  window.addEventListener('resize', onViewportChange);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', onViewportChange);
  }
  window.addEventListener('orientationchange', onViewportChange);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(syncHeaderLayout);
  }
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(function () {
        syncHeaderLayout();
        ticking = false;
      });
    }
  }, {
    passive: true
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeaderLayoutSync, {
    once: true
  });
} else {
  initHeaderLayoutSync();
}

/***/ }),

/***/ "./src/js/modules/ed-init-cart-attribute.js":
/*!**************************************************!*\
  !*** ./src/js/modules/ed-init-cart-attribute.js ***!
  \**************************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var EdInitCartAttribute = /*#__PURE__*/function (_HTMLElement) {
  function EdInitCartAttribute() {
    _classCallCheck(this, EdInitCartAttribute);
    return _callSuper(this, EdInitCartAttribute, arguments);
  }
  _inherits(EdInitCartAttribute, _HTMLElement);
  return _createClass(EdInitCartAttribute, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.currentCartAttributes = JSON.parse(this.getAttribute('current-cart-attributes') || '{}');
      this._attachListeners();
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      document.addEventListener('ed:init-cart-attribute', this.onTriggerAttribute.bind(this));
    }
  }, {
    key: "onTriggerAttribute",
    value: function onTriggerAttribute(e) {
      var attributeKey = e.detail.key;
      var attributeValue = String(e.detail.value);
      var existingValue = this.currentCartAttributes[attributeKey];
      if (existingValue === attributeValue || existingValue === 'false') return;
      this.updateCartAttribute(attributeKey, attributeValue);
    }
  }, {
    key: "updateCartAttribute",
    value: function updateCartAttribute(key, value) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: _defineProperty({}, key, value)
        })
      }).then(function () {
        console.log('cart attribute updated:', key, value);
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-init-cart-attribute', EdInitCartAttribute);

/***/ }),

/***/ "./src/js/modules/ed-lazy-app-block.js":
/*!*********************************************!*\
  !*** ./src/js/modules/ed-lazy-app-block.js ***!
  \*********************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var CUSTOM_ELEMENT_TAG = 'ed-lazy-app-block';
var EdLazyAppBlock = /*#__PURE__*/function (_HTMLElement) {
  function EdLazyAppBlock() {
    _classCallCheck(this, EdLazyAppBlock);
    return _callSuper(this, EdLazyAppBlock, arguments);
  }
  _inherits(EdLazyAppBlock, _HTMLElement);
  return _createClass(EdLazyAppBlock, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _window$Shopify,
        _this = this;
      if (this.hasAttribute('data-mounted')) return;
      this._template = this.querySelector('template[data-lazy-app-block]');
      if (!this._template) return;
      if ((_window$Shopify = window.Shopify) !== null && _window$Shopify !== void 0 && _window$Shopify.designMode || !window.IntersectionObserver) {
        this._mount();
        return;
      }
      this._observer = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) {
          return entry.isIntersecting;
        })) return;
        _this._observer.disconnect();
        _this._observer = null;
        _this._mount();
      }, {
        rootMargin: '400px 0px',
        threshold: 0
      });
      this._observer.observe(this);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _this$_observer;
      (_this$_observer = this._observer) === null || _this$_observer === void 0 || _this$_observer.disconnect();
      this._observer = null;
    }
  }, {
    key: "_mount",
    value: function _mount() {
      if (this.hasAttribute('data-mounted') || !this._template) return;
      var fragment = this._template.content.cloneNode(true);
      fragment.querySelectorAll('script').forEach(function (node) {
        var script = document.createElement('script');
        var _iterator = _createForOfIteratorHelper(node.attributes),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _step.value,
              name = _step$value.name,
              value = _step$value.value;
            script.setAttribute(name, value);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        script.textContent = node.textContent;
        node.replaceWith(script);
      });
      this._template.after(fragment);
      this._template.remove();
      this._template = null;
      this.style.minHeight = '';
      this.setAttribute('data-mounted', 'true');
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get(CUSTOM_ELEMENT_TAG)) {
  customElements.define(CUSTOM_ELEMENT_TAG, EdLazyAppBlock);
}

/***/ }),

/***/ "./src/js/modules/ed-lp-final-cta.js":
/*!*******************************************!*\
  !*** ./src/js/modules/ed-lp-final-cta.js ***!
  \*******************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var CUSTOM_ELEMENT_TAG = 'edubily-lp-final-cta';
var DEFAULT_ROTATION_MS = 1500;
var MIN_ROTATION_MS = 500;
var EdubilyLpFinalCta = /*#__PURE__*/function (_HTMLElement) {
  function EdubilyLpFinalCta() {
    var _this;
    _classCallCheck(this, EdubilyLpFinalCta);
    _this = _callSuper(this, EdubilyLpFinalCta);
    _this.rotationIntervalId = null;
    return _this;
  }
  _inherits(EdubilyLpFinalCta, _HTMLElement);
  return _createClass(EdubilyLpFinalCta, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.startVariantImageRotation();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.clearRotationInterval();
    }
  }, {
    key: "clearRotationInterval",
    value: function clearRotationInterval() {
      if (this.rotationIntervalId != null) {
        window.clearInterval(this.rotationIntervalId);
        this.rotationIntervalId = null;
      }
    }
  }, {
    key: "readVariantImageUrlList",
    value: function readVariantImageUrlList(imageEl) {
      try {
        var raw = imageEl.getAttribute('data-variant-images') || '[]';
        var parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
      } catch (_unused) {
        return [];
      }
    }
  }, {
    key: "readRotationIntervalMs",
    value: function readRotationIntervalMs() {
      var raw = this.getAttribute('data-rotation-interval-ms');
      var parsed = raw != null ? parseInt(raw, 10) : NaN;
      if (!Number.isFinite(parsed) || parsed < MIN_ROTATION_MS) {
        return DEFAULT_ROTATION_MS;
      }
      return parsed;
    }
  }, {
    key: "startVariantImageRotation",
    value: function startVariantImageRotation() {
      var _this2 = this;
      this.clearRotationInterval();
      var imageEl = this.querySelector('[data-lp-final-cta-image]');
      if (!imageEl) return;
      var urls = this.readVariantImageUrlList(imageEl);
      if (urls.length <= 1) return;
      var intervalMs = this.readRotationIntervalMs();
      var index = 0;
      this.rotationIntervalId = window.setInterval(function () {
        if (!_this2.isConnected) return;
        index = (index + 1) % urls.length;
        var next = urls[index];
        if (next) imageEl.src = next;
      }, intervalMs);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get(CUSTOM_ELEMENT_TAG)) {
  customElements.define(CUSTOM_ELEMENT_TAG, EdubilyLpFinalCta);
}

/***/ }),

/***/ "./src/js/modules/ed-lp-offer-bundle-ratings.js":
/*!******************************************************!*\
  !*** ./src/js/modules/ed-lp-offer-bundle-ratings.js ***!
  \******************************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var CUSTOM_ELEMENT_NAME = 'edubily-lp-offer-bundle-ratings';
var OFFER_BUNDLE_ELEMENT_NAME = 'edubily-lp-offer-bundle';
var REVIEWS_IO_RATING_SNIPPET_CLASS = 'ruk_rating_snippet';
var REVIEWS_IO_SCRIPT_FRAGMENT = 'widget.reviews.io/rating-snippet/dist.js';
var REVIEWS_IO_SCRIPT_URL = 'https://widget.reviews.io/rating-snippet/dist.js';
var REVIEWS_IO_STYLESHEET_URL = 'https://widget.reviews.io/rating-snippet/dist.css';
var RATING_SNIPPET_OPTIONS = {
  store: 'edubily.de',
  mode: 'default',
  color: '#e45e5e',
  linebreak: false,
  text: 'Bewertungen',
  singularText: 'Bewertung',
  lang: 'de-in',
  usePolaris: false,
  showEmptyStars: false,
  showNumericalAverageRating: false
};
var ratingSnippetFactoryHasRun = false;
function whenDocumentIsReady(run) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, {
      once: true
    });
  } else {
    run();
  }
}
function injectReviewsIoStylesheetOnce() {
  var alreadyLinked = document.querySelector("link[rel=\"stylesheet\"][href=\"".concat(REVIEWS_IO_STYLESHEET_URL, "\"]"));
  if (alreadyLinked) return;
  var link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = REVIEWS_IO_STYLESHEET_URL;
  document.head.appendChild(link);
}
function findReviewsIoSnippetScriptInDocument() {
  return Array.prototype.find.call(document.scripts, function (scriptElement) {
    return scriptElement.src && scriptElement.src.indexOf(REVIEWS_IO_SCRIPT_FRAGMENT) !== -1;
  });
}
function callRatingSnippetFactoryOnce() {
  if (ratingSnippetFactoryHasRun) return;
  if (typeof window.ratingSnippet !== 'function') return;
  ratingSnippetFactoryHasRun = true;
  window.ratingSnippet(REVIEWS_IO_RATING_SNIPPET_CLASS, RATING_SNIPPET_OPTIONS);
}
function pollUntilRatingSnippetExists(maxAttempts, delayMs, onReady) {
  var attempt = 0;
  function tick() {
    if (typeof window.ratingSnippet === 'function') {
      onReady();
      return;
    }
    if (attempt < maxAttempts) {
      attempt += 1;
      setTimeout(tick, delayMs);
    }
  }
  tick();
}
function appendReviewsIoScriptAndInit() {
  var script = document.createElement('script');
  script.src = REVIEWS_IO_SCRIPT_URL;
  script.defer = true;
  script.addEventListener('load', callRatingSnippetFactoryOnce);
  document.head.appendChild(script);
}
function bootstrapReviewsIoRatingSnippets() {
  injectReviewsIoStylesheetOnce();
  if (typeof window.ratingSnippet === 'function') {
    callRatingSnippetFactoryOnce();
    return;
  }
  var existingScript = findReviewsIoSnippetScriptInDocument();
  if (existingScript) {
    existingScript.addEventListener('load', callRatingSnippetFactoryOnce);
    pollUntilRatingSnippetExists(50, 40, callRatingSnippetFactoryOnce);
    return;
  }
  appendReviewsIoScriptAndInit();
}
var EdubilyLpOfferBundleRatings = /*#__PURE__*/function (_HTMLElement) {
  function EdubilyLpOfferBundleRatings() {
    _classCallCheck(this, EdubilyLpOfferBundleRatings);
    return _callSuper(this, EdubilyLpOfferBundleRatings, arguments);
  }
  _inherits(EdubilyLpOfferBundleRatings, _HTMLElement);
  return _createClass(EdubilyLpOfferBundleRatings, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var offerBundleRoot = this.closest(OFFER_BUNDLE_ELEMENT_NAME);
      if (!offerBundleRoot) return;
      var hasAnyRatingPlaceholder = offerBundleRoot.querySelector(".".concat(REVIEWS_IO_RATING_SNIPPET_CLASS));
      if (!hasAnyRatingPlaceholder) return;
      whenDocumentIsReady(bootstrapReviewsIoRatingSnippets);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get(CUSTOM_ELEMENT_NAME)) {
  customElements.define(CUSTOM_ELEMENT_NAME, EdubilyLpOfferBundleRatings);
}

/***/ }),

/***/ "./src/js/modules/ed-lp-offer-bundle.js":
/*!**********************************************!*\
  !*** ./src/js/modules/ed-lp-offer-bundle.js ***!
  \**********************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var themeCart = window.theme && window.theme.routes && window.theme.routes.cart;
var cartAddJsUrl = themeCart && themeCart.add ? "".concat(themeCart.add, ".js") : '/cart/add.js';
function formatThemeMoneyCents(cents) {
  var formatString = window.theme && window.theme.moneyFormat || '${{amount}}';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var match = formatString.match(placeholderRegex);
  if (!match) return String(cents);
  var value = '';
  var n = typeof cents === 'string' ? cents.replace('.', '') : cents;
  function formatWithDelimiters(number) {
    var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var thousands = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ',';
    var decimal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
    if (isNaN(number) || number == null) return '0';
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.');
    var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1".concat(thousands));
    var centsAmount = parts[1] ? decimal + parts[1] : '';
    return dollarsAmount + centsAmount;
  }
  switch (match[1]) {
    case 'amount':
      value = formatWithDelimiters(n, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(n, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(n, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(n, 0, '.', ',');
      break;
    default:
      value = formatWithDelimiters(n, 2);
  }
  return formatString.replace(placeholderRegex, value);
}
function saleDiscountPercent(price, compareAt) {
  if (!compareAt || compareAt <= price) return null;
  return Math.round((compareAt - price) * 100.0 / compareAt);
}
var CUSTOM_ELEMENT_TAG = 'edubily-lp-offer-bundle';
var EdubilyLpOfferBundle = /*#__PURE__*/function (_HTMLElement) {
  function EdubilyLpOfferBundle() {
    var _this;
    _classCallCheck(this, EdubilyLpOfferBundle);
    _this = _callSuper(this, EdubilyLpOfferBundle);
    _this.onOptionSelectChange = _this.onOptionSelectChange.bind(_this);
    _this.onAddToCartClick = _this.onAddToCartClick.bind(_this);
    return _this;
  }
  _inherits(EdubilyLpOfferBundle, _HTMLElement);
  return _createClass(EdubilyLpOfferBundle, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      var jsonEl = this.querySelector('script[type="application/json"][data-lp-offer-json]');
      if (!jsonEl) return;
      var offerPayload;
      try {
        offerPayload = JSON.parse(jsonEl.textContent);
      } catch (err) {
        console.error('lp-offer-bundle: invalid JSON', err);
        return;
      }
      this.offerPayload = offerPayload;
      this.querySelectorAll('[data-lp-offer-option-select]').forEach(function (select) {
        select.addEventListener('change', _this2.onOptionSelectChange);
      });
      this.querySelectorAll('[data-lp-offer-add]').forEach(function (button) {
        button.addEventListener('click', _this2.onAddToCartClick);
      });
      this.querySelectorAll('[data-lp-offer-card]').forEach(function (card) {
        _this2.syncCardUi(card);
      });
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _this3 = this;
      this.querySelectorAll('[data-lp-offer-option-select]').forEach(function (select) {
        select.removeEventListener('change', _this3.onOptionSelectChange);
      });
      this.querySelectorAll('[data-lp-offer-add]').forEach(function (button) {
        button.removeEventListener('click', _this3.onAddToCartClick);
      });
    }
  }, {
    key: "closestOfferCard",
    value: function closestOfferCard(element) {
      return element.closest('[data-lp-offer-card]');
    }
  }, {
    key: "findVariantById",
    value: function findVariantById(card, variantId) {
      var index = parseInt(card.dataset.cardIndex, 10);
      var cardPayload = this.offerPayload.cards[index];
      if (!cardPayload) return null;
      return cardPayload.variants.find(function (variant) {
        return String(variant.id) === String(variantId);
      });
    }
  }, {
    key: "getCardPayload",
    value: function getCardPayload(card) {
      var index = parseInt(card.dataset.cardIndex, 10);
      return this.offerPayload.cards[index] || null;
    }
  }, {
    key: "getFixedCardImageUrl",
    value: function getFixedCardImageUrl(card) {
      var cardPayload = this.getCardPayload(card);
      if (!cardPayload || !cardPayload.fixed_card_image) return '';
      return String(cardPayload.fixed_card_image);
    }
  }, {
    key: "selectedOptionValues",
    value: function selectedOptionValues(card) {
      var selects = Array.from(card.querySelectorAll('[data-lp-offer-option-select]')).sort(function (a, b) {
        var posA = parseInt(a.dataset.optionPosition || '0', 10);
        var posB = parseInt(b.dataset.optionPosition || '0', 10);
        return posA - posB;
      });
      return selects.map(function (select) {
        return select.value || '';
      });
    }
  }, {
    key: "hasEveryOptionFilled",
    value: function hasEveryOptionFilled(card) {
      var selects = card.querySelectorAll('[data-lp-offer-option-select]');
      if (!selects.length) return true;
      return this.selectedOptionValues(card).every(function (value) {
        return value !== '';
      });
    }
  }, {
    key: "variantMatchingSelections",
    value: function variantMatchingSelections(card) {
      var cardPayload = this.getCardPayload(card);
      if (!cardPayload) return null;
      var values = this.selectedOptionValues(card);
      if (!values.length || values.some(function (value) {
        return value === '';
      })) return null;
      return cardPayload.variants.find(function (variant) {
        if (!Array.isArray(variant.options)) return false;
        if (variant.options.length !== values.length) return false;
        return variant.options.every(function (opt, idx) {
          return String(opt) === String(values[idx]);
        });
      }) || null;
    }
  }, {
    key: "syncAddToCartButton",
    value: function syncAddToCartButton(card, variant) {
      var button = card.querySelector('[data-lp-offer-add]');
      if (!button) return;
      if (!variant || !variant.available) {
        button.dataset.productId = '';
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        return;
      }
      button.dataset.productId = String(variant.id);
      button.disabled = false;
      button.setAttribute('aria-disabled', 'false');
    }
  }, {
    key: "currencyCodeSuffix",
    value: function currencyCodeSuffix() {
      if (this.offerPayload.currencyCodeEnabled && this.offerPayload.currencyIso) {
        return " ".concat(this.offerPayload.currencyIso);
      }
      return '';
    }
  }, {
    key: "formatDiscountBubbleText",
    value: function formatDiscountBubbleText(percent) {
      if (percent == null) return '';
      var template = this.offerPayload.salePercentTemplate;
      if (!template) return "".concat(percent, "%");
      var filled = String(template).split('[[pct]]').join(String(percent));
      return filled.includes('[[pct]]') ? "".concat(percent, "%") : filled;
    }
  }, {
    key: "formatSavingsLineText",
    value: function formatSavingsLineText(amountFormatted) {
      var template = this.offerPayload.saveAmountTemplate;
      if (!template) return amountFormatted ? String(amountFormatted) : '';
      var filled = String(template).split('[[amt]]').join(String(amountFormatted));
      return filled.includes('[[amt]]') ? String(amountFormatted) : filled;
    }
  }, {
    key: "syncCardUi",
    value: function syncCardUi(card) {
      if (!card) return;
      var hasSelectors = card.querySelector('[data-lp-offer-option-select]');
      var variant = null;
      if (hasSelectors) {
        if (!this.hasEveryOptionFilled(card)) {
          this.syncAddToCartButton(card, null);
          return;
        }
        variant = this.variantMatchingSelections(card);
      } else {
        var button = card.querySelector('[data-lp-offer-add]');
        if (!button || !button.dataset.productId) return;
        variant = this.findVariantById(card, button.dataset.productId);
      }
      if (!variant) {
        this.syncAddToCartButton(card, null);
        return;
      }
      var imageEl = card.querySelector('[data-lp-offer-image]');
      var fixedCardImageUrl = this.getFixedCardImageUrl(card);
      if (imageEl) {
        var nextImageUrl = fixedCardImageUrl || '';
        if (nextImageUrl) {
          imageEl.src = nextImageUrl;
          imageEl.removeAttribute('srcset');
        }
      }
      var priceEl = card.querySelector('[data-lp-offer-price]');
      var compareEl = card.querySelector('[data-lp-offer-compare]');
      var bubbleEl = card.querySelector('[data-lp-offer-discount-bubble]');
      var saveEl = card.querySelector('[data-lp-offer-save]');
      var regularLabel = card.querySelector('[data-lp-offer-regular-label]');
      var suffix = this.currencyCodeSuffix();
      var onSale = Boolean(variant.compare_at_price && variant.compare_at_price > variant.price);
      if (priceEl) {
        priceEl.textContent = formatThemeMoneyCents(variant.price) + suffix;
        priceEl.className = onSale ? 'sale p-sm' : 'product-item__price p-sm ed-product-price';
      }
      if (compareEl) {
        if (onSale) {
          compareEl.textContent = formatThemeMoneyCents(variant.compare_at_price) + suffix;
          compareEl.hidden = false;
        } else {
          compareEl.textContent = '';
          compareEl.hidden = true;
        }
      }
      if (regularLabel) {
        regularLabel.hidden = !onSale;
      }
      var pct = saleDiscountPercent(variant.price, variant.compare_at_price);
      if (bubbleEl) {
        if (pct != null && pct > 0) {
          bubbleEl.textContent = this.formatDiscountBubbleText(pct);
          bubbleEl.hidden = false;
        } else {
          bubbleEl.textContent = '';
          bubbleEl.hidden = true;
        }
      }
      if (saveEl) {
        if (onSale && variant.compare_at_price > variant.price) {
          var saveCents = variant.compare_at_price - variant.price;
          var amountText = formatThemeMoneyCents(saveCents) + suffix;
          saveEl.textContent = this.formatSavingsLineText(amountText);
          saveEl.hidden = false;
        } else {
          saveEl.textContent = '';
          saveEl.hidden = true;
        }
      }
      this.syncAddToCartButton(card, variant);
    }
  }, {
    key: "onOptionSelectChange",
    value: function onOptionSelectChange(event) {
      var card = this.closestOfferCard(event.target);
      if (!card) return;
      this.syncCardUi(card);
    }
  }, {
    key: "onAddToCartClick",
    value: function onAddToCartClick(event) {
      var button = event.currentTarget;
      var variantId = button.dataset.productId;
      if (!variantId) return;
      button.classList.add('loading');
      var cartDrawer = document.querySelector('cart-drawer');
      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      if (cartDrawer) {
        formData.append('sections', 'cart-drawer,cart-icon-bubble');
        formData.append('sections_url', window.location.pathname);
      }
      fetch(cartAddJsUrl, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      }).then(function (response) {
        return response.json();
      }).then(function (payload) {
        if (payload.status === 422 || payload.description) {
          if (window.dispatchEvent) {
            window.dispatchEvent(new CustomEvent('cart:error', {
              detail: {
                errorMessage: payload.description || payload.message
              }
            }));
          }
          button.classList.remove('loading');
          return;
        }
        if (cartDrawer && payload.sections && cartDrawer.renderContents) {
          cartDrawer.renderContents(payload);
        }
        button.classList.remove('loading');
        button.classList.add('item-added');
        setTimeout(function () {
          return button.classList.remove('item-added');
        }, 2000);
      })["catch"](function (err) {
        console.error('lp-offer-bundle: add to cart failed', err);
        button.classList.remove('loading');
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get(CUSTOM_ELEMENT_TAG)) {
  customElements.define(CUSTOM_ELEMENT_TAG, EdubilyLpOfferBundle);
}

/***/ }),

/***/ "./src/js/modules/ed-reviews-io-polaris.js":
/*!*************************************************!*\
  !*** ./src/js/modules/ed-reviews-io-polaris.js ***!
  \*************************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var CUSTOM_ELEMENT_TAG = 'ed-reviews-io-polaris';
function createPolarisWidgetConfig(productSkuCsv) {
  return {
    store: 'edubily.de',
    widget: 'polaris',
    options: {
      types: 'product_review,questions',
      enable_sentiment_analysis: true,
      lang: 'de-in',
      layout: '',
      per_page: 8,
      store_review: {
        hide_if_no_results: false
      },
      third_party_review: {
        hide_if_no_results: false
      },
      product_review: {
        sku: productSkuCsv,
        hide_if_no_results: false
      },
      questions: {
        hide_if_no_results: false,
        enable_ask_question: false,
        enable_ask_question_button_style: false,
        show_dates: true,
        grouping: '[Group questions by providing a grouping variable here or a specific product SKU]'
      },
      header: {
        enable_summary: false,
        enable_ratings: false,
        enable_attributes: false,
        enable_image_gallery: false,
        enable_percent_recommended: false,
        enable_write_review: false,
        enable_ask_question: false,
        enable_sub_header: false,
        rating_decimal_places: 2,
        use_write_review_button: false,
        enable_if_no_results: false,
        show_review_title_field: false
      },
      sentiment: {
        badge_text: 'Our Customers Say'
      },
      filtering: {
        enable: false,
        enable_text_search: false,
        enable_sorting: false,
        enable_product_filter: false,
        enable_media_filter: false,
        enable_overall_rating_filter: false,
        enable_language_filter: false,
        enable_language_filter_language_change: false,
        enable_ratings_filters: false,
        enable_attributes_filters: false,
        enable_expanded_filters: false
      },
      reviews: {
        enable_avatar: true,
        enable_reviewer_name: true,
        enable_reviewer_address: true,
        reviewer_address_format: 'city, country',
        enable_verified_badge: true,
        enable_subscriber_badge: true,
        review_content_filter: 'undefined',
        enable_reviewer_recommends: false,
        enable_attributes: true,
        enable_product_name: true,
        enable_link_product: false,
        enable_review_title: undefined,
        enable_replies: true,
        enable_images: true,
        enable_ratings: true,
        enable_share: true,
        enable_helpful_vote: false,
        enable_helpful_display: false,
        enable_report: false,
        enable_date: true,
        date_format: 'undefined',
        date_location: 'undefined',
        enable_third_party_source: true,
        enable_duplicate_reviews: undefined,
        combine_title_stars: true
      }
    },
    translations: {
      'Verified Customer': 'Verified Customer'
    },
    styles: {
      '--base-font-size': '16px',
      '--common-button-font-family': 'inherit',
      '--common-button-font-size': '16px',
      '--common-button-font-weight': '500',
      '--common-button-letter-spacing': '0',
      '--common-button-text-transform': 'none',
      '--common-button-vertical-padding': '10px',
      '--common-button-horizontal-padding': '20px',
      '--common-button-border-width': '2px',
      '--common-button-border-radius': '0px',
      '--primary-button-bg-color': '#0E1311',
      '--primary-button-border-color': '#0E1311',
      '--primary-button-text-color': '#ffffff',
      '--secondary-button-bg-color': 'transparent',
      '--secondary-button-border-color': '#0E1311',
      '--secondary-button-text-color': '#0E1311',
      '--common-star-color': '#0E1311',
      '--common-star-disabled-color': 'rgba(0,0,0,0.25)',
      '--medium-star-size': '22px',
      '--small-star-size': '19px',
      '--heading-text-color': '#0E1311',
      '--heading-text-font-weight': '600',
      '--heading-text-font-family': 'inherit',
      '--heading-text-line-height': '1.4',
      '--heading-text-letter-spacing': '0',
      '--heading-text-transform': 'none',
      '--body-text-color': '#0E1311',
      '--body-text-font-weight': '400',
      '--body-text-font-family': 'inherit',
      '--body-text-line-height': '1.4',
      '--body-text-letter-spacing': '0',
      '--body-text-transform': 'none',
      '--inputfield-text-font-family': 'inherit',
      '--input-text-font-size': '14px',
      '--inputfield-text-font-weight': '400',
      '--inputfield-text-color': '#0E1311',
      '--inputfield-border-color': 'rgba(0,0,0,0.2)',
      '--inputfield-background-color': 'transparent',
      '--inputfield-border-width': '1px',
      '--inputfield-border-radius': '0px',
      '--common-border-color': 'rgba(0,0,0,0.15)',
      '--common-border-width': '1px',
      '--common-sidebar-width': '190px',
      '--filters-panel-bg-color': 'transparent',
      '--filters-panel-font-size': '16px',
      '--filters-panel-text-color': '16px',
      '--filters-panel-horizontal-padding': '0',
      '--filters-panel-vertical-padding': '0',
      '--slider-indicator-bg-color': 'rgba(0,0,0,0.1)',
      '--slider-indicator-button-color': '#0E1311',
      '--slider-indicator-width': '190px',
      '--badge-icon-color': '#0E1311',
      '--badge-icon-font-size': 'inherit',
      '--badge-text-color': '#0E1311',
      '--badge-text-font-size': 'inherit',
      '--badge-text-letter-spacing': 'inherit',
      '--badge-text-transform': 'inherit',
      '--author-font-size': 'inherit',
      '--author-text-transform': 'none',
      '--avatar-thumbnail-size': '60px',
      '--avatar-thumbnail-border-radius': '100px',
      '--avatar-thumbnail-text-color': '#0E1311',
      '--avatar-thumbnail-bg-color': 'rgba(0,0,0,0.1)',
      '--photo-video-thumbnail-size': '80px',
      '--photo-video-thumbnail-border-radius': '0px',
      '--mediaslider-scroll-button-icon-color': '#0E1311',
      '--mediaslider-scroll-button-bg-color': 'rgba(255, 255, 255, 0.85)',
      '--mediaslider-overlay-text-color': '#ffffff',
      '--mediaslider-overlay-bg-color': 'rgba(0, 0, 0, 0.8)',
      '--mediaslider-item-size': '110px',
      '--pagination-tab-text-color': '#0E1311',
      '--pagination-tab-text-transform': 'none',
      '--pagination-tab-text-letter-spacing': '0',
      '--pagination-tab-text-font-size': '16px',
      '--pagination-tab-text-font-weight': '600',
      '--pagination-tab-active-text-color': '#0E1311',
      '--pagination-tab-active-text-font-weight': '600',
      '--pagination-tab-active-border-color': '#0E1311',
      '--pagination-tab-border-width': '3px',
      '--sentiment-base-font-size': '15px',
      '--sentiment-panel-bg-color': 'transparent',
      '--sentiment-panel-border-size': '1px',
      '--sentiment-panel-border-color': 'rgba(0, 0, 0, 0.1)',
      '--sentiment-panel-border-radius': '0px',
      '--sentiment-panel-shadow-size': '0px',
      '--sentiment-panel-shadow-color': 'rgba(0, 0, 0, 0.1)',
      '--sentiment-heading-text-color': '#0E1311',
      '--sentiment-heading-text-font-weight': '600',
      '--sentiment-heading-text-font-family': 'inherit',
      '--sentiment-heading-text-line-height': '1.4',
      '--sentiment-heading-text-letter-spacing': '0',
      '--sentiment-heading-text-transform': 'none',
      '--sentiment-body-text-color': '#0E1311',
      '--sentiment-body-text-font-weight': '400',
      '--sentiment-body-text-font-family': 'inherit',
      '--sentiment-body-text-line-height': '1.4',
      '--sentiment-body-text-letter-spacing': '0',
      '--sentiment-body-text-transform': 'none',
      '--sentiment-panel-vertical-padding': '25px',
      '--sentiment-panel-horizontal-padding': '20px',
      '--sentiment-header-text-color': 'inherit',
      '--sentiment-header-text-font-size': '12px',
      '--sentiment-header-text-font-weight': 'inherit',
      '--sentiment-header-bg-color': 'rgba(0, 0, 0, 0.04)',
      '--sentiment-header-border-radius': '50px',
      '--sentiment-header-shadow-size': '0px',
      '--sentiment-header-shadow-color': 'rgba(0, 0, 0, 0.1)',
      '--sentiment-header-vertical-padding': '7px',
      '--sentiment-header-horizontal-padding': '10px',
      '--sentiment-pagination-tab-text-font-size': '13px',
      '--sentiment-pagination-tab-text-font-weight': '600',
      '--sentiment-pagination-tab-text-color': '#0E1311',
      '--sentiment-pagination-tab-text-transform': 'none',
      '--sentiment-pagination-tab-text-letter-spacing': '0',
      '--sentiment-pagination-tab-active-text-color': '#0E1311',
      '--sentiment-pagination-tab-active-text-font-weight': '600',
      '--sentiment-pagination-tab-active-border-color': '#0E1311',
      '--sentiment-pagination-tab-border-width': '3px'
    }
  };
}
var EdReviewsIoPolaris = /*#__PURE__*/function (_HTMLElement) {
  function EdReviewsIoPolaris() {
    var _this;
    _classCallCheck(this, EdReviewsIoPolaris);
    _this = _callSuper(this, EdReviewsIoPolaris);
    _this.mountRoot = null;
    _this.mountSelector = '';
    _this.shopifySectionId = '';
    _this.productSkuCsv = '';
    _this.onDomContentLoaded = _this.onDomContentLoaded.bind(_this);
    _this.onSectionLoad = _this.onSectionLoad.bind(_this);
    return _this;
  }
  _inherits(EdReviewsIoPolaris, _HTMLElement);
  return _createClass(EdReviewsIoPolaris, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.mountRoot = this.querySelector('.reviews-io-polaris-root');
      if (!this.mountRoot || !this.mountRoot.id) return;
      this.mountSelector = "#".concat(this.mountRoot.id);
      this.shopifySectionId = this.dataset.sectionId || '';
      this.productSkuCsv = typeof this.dataset.sku === 'string' ? this.dataset.sku : '';
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.onDomContentLoaded);
      } else {
        this.mountReviewsWidgetWhenReady();
      }
      document.addEventListener('shopify:section:load', this.onSectionLoad);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.onDomContentLoaded);
      document.removeEventListener('shopify:section:load', this.onSectionLoad);
    }
  }, {
    key: "onDomContentLoaded",
    value: function onDomContentLoaded() {
      this.mountReviewsWidgetWhenReady();
    }
  }, {
    key: "onSectionLoad",
    value: function onSectionLoad(event) {
      if (!event.target || event.target.id !== "shopify-section-".concat(this.shopifySectionId)) {
        return;
      }
      var root = this.mountRoot;
      if (root) {
        root.removeAttribute('data-reviewsio-inited');
        root.innerHTML = '';
      }
      this.mountReviewsWidgetWhenReady();
    }
  }, {
    key: "mountReviewsWidgetWhenReady",
    value: function mountReviewsWidgetWhenReady() {
      var _this2 = this;
      if (typeof window.ReviewsWidget !== 'function') {
        window.setTimeout(function () {
          return _this2.mountReviewsWidgetWhenReady();
        }, 60);
        return;
      }
      var root = this.mountRoot;
      if (!root || root.getAttribute('data-reviewsio-inited') === 'true') return;
      root.setAttribute('data-reviewsio-inited', 'true');
      new window.ReviewsWidget(this.mountSelector, createPolarisWidgetConfig(this.productSkuCsv));
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get(CUSTOM_ELEMENT_TAG)) {
  customElements.define(CUSTOM_ELEMENT_TAG, EdReviewsIoPolaris);
}

/***/ }),

/***/ "./src/js/modules/ed-upsell-under-atc.js":
/*!***********************************************!*\
  !*** ./src/js/modules/ed-upsell-under-atc.js ***!
  \***********************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var CUSTOM_ELEMENT_TAG = 'ed-upsell-under-atc';
var ADD_TO_CART_SUCCESS_FEEDBACK_MS = 2200;
var SELECTORS = {
  addToCartButton: '[data-ed-upsell-atc-button]',
  variantIdField: '[name="id"]'
};
var CART_ADD_SECTION_IDS = 'cart-drawer,cart-icon-bubble';
var DOCUMENT_VARIANT_EVENTS = ['product:variant-change', 'variant:changed', 'variantChange'];
function resolveCartAddJsUrl() {
  var themeCartRoutes = typeof window.theme !== 'undefined' && window.theme.routes ? window.theme.routes.cart : null;
  var fromTheme = themeCartRoutes && themeCartRoutes.add;
  var fromWindowRoutes = typeof window.routes !== 'undefined' ? window.routes.cart_add_url : null;
  var baseUrl = fromTheme || fromWindowRoutes || '/cart/add';
  var withoutTrailingSlash = String(baseUrl).replace(/\/$/, '');
  return withoutTrailingSlash.endsWith('.js') ? withoutTrailingSlash : "".concat(withoutTrailingSlash, ".js");
}
function parsePositiveIntegerOrNull(raw) {
  if (raw === undefined || raw === null || raw === '') return null;
  var parsed = parseInt(String(raw), 10);
  return Number.isNaN(parsed) ? null : parsed;
}
function readVariantIdFromProductForm(formElement) {
  if (!formElement) return null;
  var variantField = formElement.querySelector(SELECTORS.variantIdField);
  if (!variantField || variantField.value === '') return null;
  return parsePositiveIntegerOrNull(variantField.value);
}
function readVariantIdFromQueryString() {
  var variantParam = new URLSearchParams(window.location.search).get('variant');
  if (!variantParam) return null;
  return parsePositiveIntegerOrNull(variantParam);
}
var EdUpsellUnderAtc = /*#__PURE__*/function (_HTMLElement) {
  function EdUpsellUnderAtc() {
    _classCallCheck(this, EdUpsellUnderAtc);
    return _callSuper(this, EdUpsellUnderAtc, arguments);
  }
  _inherits(EdUpsellUnderAtc, _HTMLElement);
  return _createClass(EdUpsellUnderAtc, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this = this;
      if (this._isInitialized) return;
      this._isInitialized = true;
      this._productFormElement = this.closest('form');
      this._addToCartButton = this.querySelector(SELECTORS.addToCartButton);
      this._successFeedbackTimeoutId = null;
      this._onProductFormChange = function () {
        return _this.updateVisibility();
      };
      this._onDocumentVariantEvent = function () {
        return _this.updateVisibility();
      };
      this._attachProductFormListeners();
      this._attachDocumentVariantListeners();
      if (this._addToCartButton) {
        this._addToCartButton.addEventListener('click', function () {
          return _this.handleAddToCart();
        });
      }
      requestAnimationFrame(function () {
        return _this.updateVisibility();
      });
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (!this._isInitialized) return;
      this._isInitialized = false;
      this._detachProductFormListeners();
      this._detachDocumentVariantListeners();
      if (this._successFeedbackTimeoutId !== null) {
        clearTimeout(this._successFeedbackTimeoutId);
        this._successFeedbackTimeoutId = null;
      }
    }
  }, {
    key: "updateVisibility",
    value: function updateVisibility() {
      var requiredMainVariantId = parsePositiveIntegerOrNull(this.dataset.visibleForVariantId);
      if (requiredMainVariantId === null) {
        this._setHostHidden(true);
        return;
      }
      var selectedMainVariantId = readVariantIdFromProductForm(this._productFormElement);
      if (selectedMainVariantId === null) {
        selectedMainVariantId = readVariantIdFromQueryString();
      }
      var shouldShowBlock = selectedMainVariantId === requiredMainVariantId;
      this._setHostHidden(!shouldShowBlock);
    }
  }, {
    key: "handleAddToCart",
    value: function handleAddToCart() {
      var _this2 = this;
      if (!this._addToCartButton || this._addToCartButton.disabled) return;
      var upsellVariantId = parsePositiveIntegerOrNull(this.dataset.upsellVariantId);
      if (upsellVariantId === null) return;
      var cartDrawerElement = document.querySelector('cart-drawer');
      var formData = this._buildCartAddFormData(upsellVariantId, cartDrawerElement);
      this._setAddToCartButtonBusy(true);
      fetch(resolveCartAddJsUrl(), {
        method: 'POST',
        credentials: 'include',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      }).then(function (response) {
        return response.json();
      }).then(function (payload) {
        if (_this2._isCartAddErrorResponse(payload)) {
          console.warn(CUSTOM_ELEMENT_TAG, payload.description || payload.message);
          return;
        }
        _this2._refreshCartDrawerFromResponse(cartDrawerElement, payload);
        _this2._emitCartUpdatedEvents(payload);
        _this2._flashItemAddedState();
      })["catch"](function (error) {
        console.error(CUSTOM_ELEMENT_TAG, error);
      })["finally"](function () {
        _this2._setAddToCartButtonBusy(false);
      });
    }
  }, {
    key: "_attachProductFormListeners",
    value: function _attachProductFormListeners() {
      if (!this._productFormElement) return;
      this._productFormElement.addEventListener('change', this._onProductFormChange);
      var variantField = this._productFormElement.querySelector(SELECTORS.variantIdField);
      if (variantField) {
        variantField.addEventListener('change', this._onProductFormChange);
      }
    }
  }, {
    key: "_detachProductFormListeners",
    value: function _detachProductFormListeners() {
      if (!this._productFormElement) return;
      this._productFormElement.removeEventListener('change', this._onProductFormChange);
      var variantField = this._productFormElement.querySelector(SELECTORS.variantIdField);
      if (variantField) {
        variantField.removeEventListener('change', this._onProductFormChange);
      }
    }
  }, {
    key: "_attachDocumentVariantListeners",
    value: function _attachDocumentVariantListeners() {
      for (var _i = 0, _DOCUMENT_VARIANT_EVE = DOCUMENT_VARIANT_EVENTS; _i < _DOCUMENT_VARIANT_EVE.length; _i++) {
        var eventName = _DOCUMENT_VARIANT_EVE[_i];
        document.addEventListener(eventName, this._onDocumentVariantEvent);
      }
    }
  }, {
    key: "_detachDocumentVariantListeners",
    value: function _detachDocumentVariantListeners() {
      for (var _i2 = 0, _DOCUMENT_VARIANT_EVE2 = DOCUMENT_VARIANT_EVENTS; _i2 < _DOCUMENT_VARIANT_EVE2.length; _i2++) {
        var eventName = _DOCUMENT_VARIANT_EVE2[_i2];
        document.removeEventListener(eventName, this._onDocumentVariantEvent);
      }
    }
  }, {
    key: "_setHostHidden",
    value: function _setHostHidden(shouldHide) {
      if (shouldHide) {
        this.setAttribute('hidden', '');
      } else {
        this.removeAttribute('hidden');
      }
    }
  }, {
    key: "_buildCartAddFormData",
    value: function _buildCartAddFormData(upsellVariantId, cartDrawerElement) {
      var formData = new FormData();
      formData.append('id', String(upsellVariantId));
      formData.append('quantity', '1');
      if (cartDrawerElement) {
        formData.append('sections', CART_ADD_SECTION_IDS);
        formData.append('sections_url', window.location.pathname);
        if (typeof cartDrawerElement.setActiveElement === 'function') {
          cartDrawerElement.setActiveElement(this._addToCartButton);
        }
      }
      return formData;
    }
  }, {
    key: "_isCartAddErrorResponse",
    value: function _isCartAddErrorResponse(payload) {
      return payload.status === 422 || Boolean(payload.description);
    }
  }, {
    key: "_refreshCartDrawerFromResponse",
    value: function _refreshCartDrawerFromResponse(cartDrawerElement, payload) {
      if (!cartDrawerElement || !payload.sections || typeof cartDrawerElement.renderContents !== 'function') {
        return;
      }
      cartDrawerElement.renderContents(payload);
      if (cartDrawerElement.classList && cartDrawerElement.classList.contains('is-empty')) {
        cartDrawerElement.classList.remove('is-empty');
      }
    }
  }, {
    key: "_emitCartUpdatedEvents",
    value: function _emitCartUpdatedEvents(payload) {
      document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
      document.dispatchEvent(new CustomEvent('cart:item-added', {
        detail: {
          product: payload
        }
      }));
    }
  }, {
    key: "_flashItemAddedState",
    value: function _flashItemAddedState() {
      var _this3 = this;
      this._addToCartButton.classList.add('item-added');
      if (this._successFeedbackTimeoutId !== null) {
        clearTimeout(this._successFeedbackTimeoutId);
      }
      this._successFeedbackTimeoutId = window.setTimeout(function () {
        _this3._addToCartButton.classList.remove('item-added');
        _this3._successFeedbackTimeoutId = null;
      }, ADD_TO_CART_SUCCESS_FEEDBACK_MS);
    }
  }, {
    key: "_setAddToCartButtonBusy",
    value: function _setAddToCartButtonBusy(isBusy) {
      if (isBusy) {
        this._addToCartButton.classList.add('loading');
        this._addToCartButton.setAttribute('aria-busy', 'true');
      } else {
        this._addToCartButton.classList.remove('loading');
        this._addToCartButton.removeAttribute('aria-busy');
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get(CUSTOM_ELEMENT_TAG)) {
  customElements.define(CUSTOM_ELEMENT_TAG, EdUpsellUnderAtc);
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
var __webpack_exports__ = {};
/*!**************************!*\
  !*** ./src/js/custom.js ***!
  \**************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _modules_ed_filter_accordion_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./modules/ed-filter-accordion.js */ "./src/js/modules/ed-filter-accordion.js");
/* harmony import */ var _modules_ed_filter_accordion_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_filter_accordion_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _modules_ed_header_layout_sync_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./modules/ed-header-layout-sync.js */ "./src/js/modules/ed-header-layout-sync.js");
/* harmony import */ var _modules_ed_init_cart_attribute_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./modules/ed-init-cart-attribute.js */ "./src/js/modules/ed-init-cart-attribute.js");
/* harmony import */ var _modules_ed_init_cart_attribute_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_init_cart_attribute_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _modules_ed_lazy_app_block_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./modules/ed-lazy-app-block.js */ "./src/js/modules/ed-lazy-app-block.js");
/* harmony import */ var _modules_ed_lazy_app_block_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_lazy_app_block_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _modules_ed_lp_final_cta_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./modules/ed-lp-final-cta.js */ "./src/js/modules/ed-lp-final-cta.js");
/* harmony import */ var _modules_ed_lp_final_cta_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_lp_final_cta_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _modules_ed_lp_offer_bundle_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./modules/ed-lp-offer-bundle.js */ "./src/js/modules/ed-lp-offer-bundle.js");
/* harmony import */ var _modules_ed_lp_offer_bundle_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_lp_offer_bundle_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _modules_ed_lp_offer_bundle_ratings_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./modules/ed-lp-offer-bundle-ratings.js */ "./src/js/modules/ed-lp-offer-bundle-ratings.js");
/* harmony import */ var _modules_ed_lp_offer_bundle_ratings_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_lp_offer_bundle_ratings_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _modules_ed_founders_gf_ratings_cleanup_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./modules/ed-founders-gf-ratings-cleanup.js */ "./src/js/modules/ed-founders-gf-ratings-cleanup.js");
/* harmony import */ var _modules_ed_founders_gf_ratings_cleanup_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_founders_gf_ratings_cleanup_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _modules_ed_reviews_io_polaris_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./modules/ed-reviews-io-polaris.js */ "./src/js/modules/ed-reviews-io-polaris.js");
/* harmony import */ var _modules_ed_reviews_io_polaris_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_reviews_io_polaris_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _modules_ed_upsell_under_atc_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./modules/ed-upsell-under-atc.js */ "./src/js/modules/ed-upsell-under-atc.js");
/* harmony import */ var _modules_ed_upsell_under_atc_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_upsell_under_atc_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _modules_ed_cart_progress_bar_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./modules/ed-cart-progress-bar.js */ "./src/js/modules/ed-cart-progress-bar.js");
/* harmony import */ var _modules_ed_cart_progress_bar_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_cart_progress_bar_js__WEBPACK_IMPORTED_MODULE_10__);
/*
DO NOT TOUCH THIS FILE OUTSIDE OF /src DIRECTORY
this file gets compiled ./assets/custom.js - make sure to import every module here.
*/












})();

// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
/*!******************************!*\
  !*** ./src/scss/custom.scss ***!
  \******************************/
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin

})();

/******/ })()
;